import type { AuthRepository } from "../../domain/repositories/auth-repository";
import { toAuthSession } from "../mappers/auth-mapper";
import { parseResponse } from "@/core/data/parse-response";
import { appConfig } from "@/core/config";

/** `LoginResponse` from OpenAPI (`data`), snake_case from JSON. */
type LoginData = {
  access_token: string;
  refresh_token: string;
};

export const httpAuthRepository: AuthRepository = {
  login: async (credentials) => {
    const res = await fetch(`${appConfig.apiBaseUrl}/api/v1/auth/login`, {
      method: "POST",
      body: JSON.stringify(credentials),
      headers: { "Content-Type": "application/json" },
    });
    const data = await parseResponse<LoginData>(res);
    return toAuthSession(
      { accessToken: data.access_token, refreshToken: data.refresh_token },
      credentials.email,
    );
  },
};
